// Wing — internationalization. 7 languages: NL (default), EN, DE, ES, FR, IT, ZH.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nl from "./locales/nl.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";

export const SUPPORTED_LANGS = [
    { code: "nl", label: "Nederlands", flag: "🇳🇱" },
    { code: "en", label: "English",    flag: "🇬🇧" },
    { code: "de", label: "Deutsch",    flag: "🇩🇪" },
    { code: "es", label: "Español",    flag: "🇪🇸" },
    { code: "fr", label: "Français",   flag: "🇫🇷" },
    { code: "it", label: "Italiano",   flag: "🇮🇹" },
    { code: "zh", label: "中文",        flag: "🇨🇳" },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            nl: { translation: nl },
            en: { translation: en },
            de: { translation: de },
            es: { translation: es },
            fr: { translation: fr },
            it: { translation: it },
            zh: { translation: zh },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "wing_lang",
        },
    });

export default i18n;
